export const PX_PER_MM = 96 / 25.4

// Offset generations before the unit contract was restored persisted canvas
// pixels in baseLayout.width/height. The editor and the 3D parameter parser
// use millimetres, so repair that representation when opening a saved JSON.
export function normalizePersistedBaseLayoutDimensions(form2dData = {}, json2d) {
    const baseLayout = { ...(form2dData.baseLayout || {}) }
    const width = Number(baseLayout.width)
    const height = Number(baseLayout.height)
    const unit = String(baseLayout.dimensionsUnit || '').toLowerCase()
    let isCanvasPixels = unit === 'canvas-px' || unit === 'px'

    if (!isCanvasPixels && !unit && Number.isFinite(width) && Number.isFinite(height)) {
        try {
            const json = typeof json2d === 'string' ? JSON.parse(json2d) : json2d
            const background = json?.objects?.find(object => object?.id === 'background')
            const backgroundWidth = Math.abs(Number(background?.width) * Number(background?.scaleX || 1))
            const backgroundHeight = Math.abs(Number(background?.height) * Number(background?.scaleY || 1))
            const widthRatio = backgroundWidth > 0 ? width / backgroundWidth : 0
            const heightRatio = backgroundHeight > 0 ? height / backgroundHeight : 0
            isCanvasPixels = widthRatio >= 0.9 && widthRatio <= 1.1
                && heightRatio >= 0.9 && heightRatio <= 1.1
        } catch {
            // A malformed legacy JSON should not prevent the design opening.
        }
    }

    if (isCanvasPixels) {
        if (Number.isFinite(width)) baseLayout.width = width / PX_PER_MM
        if (Number.isFinite(height)) baseLayout.height = height / PX_PER_MM
    }
    baseLayout.dimensionsUnit = 'mm'
    return { ...form2dData, baseLayout }
}
